import React, { useEffect } from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import s from './s.module.less';
import AIChat from 'components/AIChat';
import PPAOnboardingHeader from 'components/PPAOnboardingHeader';
import SuccessImg from 'pages/PPAAdvanceSettingSuccessPage/imgs/success.png';
import { PATH } from 'constants/path';
import { EAIChatPageId } from 'types/ai';
import { saveStep, getStep } from 'api/ppaOnboarding';
import { EInvitedProviderStep } from '../steps';

// https://www.figma.com/design/aGY2cI5da2oGElG6GEd0Wo/Group-Practice?node-id=4914-8964&m=dev
export default function InvitedProviderAdvancedSettingsSuccessPage() {
    const navigate = useNavigate();

    useEffect(() => {
        let cancelled = false;
        (async () => {
            const stepRes = await getStep();
            const saved = stepRes?.data?.data?.currentStep;
            if (cancelled) return;
            // Already completed (e.g. revisiting the URL after finishing) — go straight home.
            if (saved === EInvitedProviderStep.COMPLETED) {
                navigate(PATH.DASHBOARD, { replace: true });
                return;
            }
            const res = await saveStep(EInvitedProviderStep.COMPLETED, true);
            if (res.error) {
                console.error('Failed to save step:', res.error);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [navigate]);

    return (
        <div className={s.wrap}>
            <PPAOnboardingHeader showLogout />
            <div className={s.content}>
                <div className={s.contentWrap}>
                    <div className={s.contentIn}>
                        <img src={SuccessImg} className={s.successImg} alt="success" />
                        <h2>Advanced settings saved successfully!</h2>
                        <div className={s.subTitle}>
                            Your updates have been saved. Stripe is now verifying your payment details. We&apos;ll
                            notify you once everything is confirmed.
                        </div>
                        <Button type="primary" className={s.goBtn} onClick={() => navigate(PATH.DASHBOARD)}>
                            Go to homepage
                        </Button>
                    </div>
                    <div className={s.chatWrap}>
                        <AIChat
                            pageId={EAIChatPageId.PROVIDER_ONBOARDING_ADVANCE_SETTING_SUCCESS}
                            defaultShow={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
